/*
 * FOR SALE — pages d'information (Fonctionnement, FAQ, Avis) : navigation de page (snippet fs-info-nav).
 * Le lien [data-fs-info-toc] de la section à l'écran porte aria-current="true" (sommaire de Fonctionnement, index des
 * thèmes de la FAQ) ; « Aller à… » / « Thèmes » (téléphone) se referme après un choix. Ces pages ne dépendent d'aucun
 * jeu : ni univers, ni ?game=, ni clé de session fs-game (retour de Charles, 8 octobre 2026).
 */
(() => {
  const root = document.querySelector('[data-fs-info-page]');
  if (!root) return;

  /* ---- Sommaire : section à l'écran ---- */
  const tocLinks = [...root.querySelectorAll('a[data-fs-info-toc]')];
  const targets = tocLinks.map((link) => document.getElementById(link.dataset.fsInfoToc)).filter(Boolean);
  if (targets.length && 'IntersectionObserver' in window) {
    const visible = new Map();
    const mark = () => {
      const shown = targets.filter((target) => visible.get(target) && !target.hidden && !target.hasAttribute('data-fs-faq-hidden'));
      const active = shown[0] ?? null;
      tocLinks.forEach((link) => {
        if (active && link.dataset.fsInfoToc === active.id) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => visible.set(entry.target, entry.isIntersecting));
      mark();
    }, { rootMargin: '-140px 0px -55% 0px' });
    targets.forEach((target) => observer.observe(target));
    root.addEventListener('fs:info-filter', mark);
  }

  /* ---- « Aller à… » (téléphone) : se referme après un choix ---- */
  root.querySelectorAll('.fs-info-jump').forEach((jump) => {
    jump.addEventListener('click', (event) => { if (event.target.closest?.('a')) jump.open = false; });
  });
})();
